import { tableColumnType, TableTypeEnum } from "../../../../assets/utils/enums/table";
import DataTable from "../../../../components/ui/table";
import { useOutletContext, useParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import getData from "../../../../api/project-request";
import { LoaderOutletContext } from "./main";
import toast from "react-hot-toast";
import CustomToast from "../../../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../../../assets/utils/enums/toast";
import { CompanyRow, SellingRow } from "../../../../assets/utils/table-types";
import { API_URL_BASKET } from "../../../../constants";
import { authFetch } from "../../../../api/authFetch";

export default function ObjectsBasket() {
    const { id } = useParams<{ id: string }>();
    const { setLoaderState } =
        useOutletContext<LoaderOutletContext>();

    const [data, setData] = useState<any[]>([]);
    const [isReady, setIsReady] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);

    const objectType = id ?? TableTypeEnum.PROJECTS;

    const endpoint = useMemo(() => {
        return (
            `${API_URL_BASKET}/get-all-${objectType}`
        );
    }, [objectType]);


    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            setIsReady(false);
            setLoaderState(true);

            try {
                const result = await getData(endpoint);
                if (!isMounted) return;

                setData(Array.isArray(result) ? result : []);
                setIsReady(true);
            } catch {
                if (!isMounted) return;
                setData([]);
                setIsReady(true);
            } finally {
                setIsUpdated(false);
                if (isMounted) setLoaderState(false);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endpoint, isUpdated]);


    const normalizedData = useMemo(() => {
        if (!Array.isArray(data)) return [];

        switch (id) {
            case TableTypeEnum.COMPANIES:
                return data.map(x => ({
                    ...x as CompanyRow
                }));

            case TableTypeEnum.SELLING:
                return data.map(x => ({
                    ...x as SellingRow
                }));

            default:
                return data;
        }
    }, [data, id]);


    // const [objectTypePath, setObjectType] = useState<TableTypeEnum>(TableTypeEnum.PROJECTS);
    if (!isReady) {
        return <div className="w-100 mt-3" />; // або skeleton
    }
    return (
        <div className="w-100 mt-3">
            <DataTable
                key={id}
                table={("expense" === String(id) || "income" === String(id)) ? tableColumnType[TableTypeEnum.FINANCE] : tableColumnType[id as TableTypeEnum]}
                data={normalizedData}
                // data={objectType === TableTypeEnum.PROJECTS ? projectData : objectType === TableTypeEnum.TASKS ? tasksData : objectType === TableTypeEnum.CLIENTS ? clients : objectType === TableTypeEnum.COMPANIES ? companies : objectType === TableTypeEnum.SELLING ? sellingColumns[0].items : objectType === "expense" as TableTypeEnum ? expenseData : objectType === "income" as TableTypeEnum ? incomeData : []}
                restoreItemsFunc={async (items) => {
                    const response = await authFetch(`${API_URL_BASKET}/restore-${objectType === "clients" ? "contacts" : objectType}`, {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ ids: items }),
                    });

                    if (response.ok) {
                        setIsUpdated(true);
                        toast((t) => (
                            <CustomToast
                                t={t}
                                type={ToastTypeEnum.INFO}
                                text={"Відновлення успішне."}
                            />
                        ));
                        return;
                    }
                    toast((t) => (
                        <CustomToast
                            t={t}
                            type={ToastTypeEnum.WARNING}
                            text={"Щось пішло не так.\nНевдалось відновити елементи."}
                        />
                    ));
                }}
            //isFinanceTitle={"expense" === String(id) ? FinanceTypeTable.EXPENSE : "income" === String(id) ? FinanceTypeTable.INCOME : undefined}

            />
        </div>
    )
}